var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    {
      staticClass: "workspace-module-container",
      attrs: { id: "workspace-photo-tips" }
    },
    [
      _c("div", { staticClass: "workspace-photo-tips-label" }, [
        _vm._v("\n            Загрузка фотографий\n        ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "workspace-photo-tips-description" }, [
        _vm._v(
          "\n            Для достижения наилучших результатов мы рекомендуем использовать подходящие изображения:\n        "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "photo-tips-grid-container" }, [
        _c("div", { staticClass: "photo-tips-left-grid" }, [
          _c("div", { staticClass: "photo-tip-container left-tip" }, [
            _c("img", {
              staticClass: "photo-tip-img-left",
              attrs: {
                src: _vm.urlForStatic(
                  "/img/projectPreviewsDemo/photo_tip_1.png"
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "photo-tip-text-box" }, [
              _c(
                "div",
                { staticClass: "photo-tip-label" },
                [
                  _c("SVGCross", { staticClass: "red-cross" }),
                  _vm._v(
                    "\n                            Нечёткое изображение\n                        "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "photo-tip-text" }, [
                _vm._v(
                  "\n                            Изображение объекта должно быть в фокусе и полностью помещаться в кадр\n                        "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "photo-tip-container left-tip" }, [
            _c("img", {
              staticClass: "photo-tip-img-left",
              attrs: {
                src: _vm.urlForStatic(
                  "/img/projectPreviewsDemo/photo_tip_2.png"
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "photo-tip-text-box" }, [
              _c(
                "div",
                { staticClass: "photo-tip-label" },
                [
                  _c("SVGCross", { staticClass: "red-cross" }),
                  _vm._v(
                    "\n                            Фото слишком тёмное\n                        "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "photo-tip-text" }, [
                _vm._v(
                  "\n                            Фотография сделана при недостаточной освещенности, что будет сказываться на точности проектирования\n                        "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "photo-tip-container left-tip" }, [
            _c("img", {
              staticClass: "photo-tip-img-left",
              attrs: {
                src: _vm.urlForStatic(
                  "/img/projectPreviewsDemo/photo_tip_3.png"
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "photo-tip-text-box" }, [
              _c(
                "div",
                { staticClass: "photo-tip-label" },
                [
                  _c("SVGCross", { staticClass: "red-cross" }),
                  _vm._v(
                    "\n                            Посторонние объекты\n                        "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "photo-tip-text" }, [
                _vm._v(
                  "\n                            Фотография содержит другие объекты на переднем плане, которые мешают проектированию\n                        "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "photo-tip-container left-tip" }, [
            _c("img", {
              staticClass: "photo-tip-img-left",
              attrs: {
                src: _vm.urlForStatic(
                  "/img/projectPreviewsDemo/photo_tip_5.jpeg"
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "photo-tip-text-box" }, [
              _c(
                "div",
                { staticClass: "photo-tip-label" },
                [
                  _c("SVGCross", { staticClass: "red-cross" }),
                  _vm._v(
                    "\n                            Неправильная перспектива\n                        "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "photo-tip-text" }, [
                _vm._v(
                  "\n                            Линии углов дома должны быть наиболее паралельны вертикалям фотографии\n                        "
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "photo-tip-container right-tip" }, [
          _c("img", {
            staticClass: "photo-tip-img-right",
            attrs: {
              src: _vm.urlForStatic("/img/projectPreviewsDemo/photo_tip_4.jpg")
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "photo-tip-text-box" }, [
            _c("div", { staticClass: "photo-tip-label" }, [
              _vm._v(
                "\n                        Подходящее изображение\n                    "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-item" },
              [
                _c("SVGChecked", { staticClass: "green-check" }),
                _vm._v(" "),
                _c("span", { staticClass: "photo-tip-text-left" }, [
                  _vm._v("Изображение объекта в фокусе")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-item" },
              [
                _c("SVGChecked", { staticClass: "green-check" }),
                _vm._v(" "),
                _c("span", { staticClass: "photo-tip-text-left" }, [
                  _vm._v("Здание полностью помещается в кадр")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-item" },
              [
                _c("SVGChecked", { staticClass: "green-check" }),
                _vm._v(" "),
                _c("span", { staticClass: "photo-tip-text-left" }, [
                  _vm._v("Фото сделано при достаточном освещении")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-item" },
              [
                _c("SVGChecked", { staticClass: "green-check" }),
                _vm._v(" "),
                _c("span", { staticClass: "photo-tip-text-left" }, [
                  _vm._v(
                    "На фото отсутствуют посторонние объекты, мешающие обзору"
                  )
                ])
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }